import { render, staticRenderFns } from "./pasteImgModal.vue?vue&type=template&id=0789f884"
import script from "./pasteImgModal.vue?vue&type=script&lang=js"
export * from "./pasteImgModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports